'use client';

import { useEffect } from 'react';
import { useIsMobile } from '@/lib/hooks/useIsMobile';
import {
  useContentDimensions,
  useLayoutDimensionsStore,
} from '@/lib/providers/LayoutDimensionsStoreProvider';

export const TOP_NAV_HEIGHT_CSS_VAR = '--top-nav-height';
export const CONTENT_WIDTH_CSS_VAR = '--content-width';
export const CONTENT_HEIGHT_CSS_VAR = '--content-height';

export const LayoutDimensionsCSSVars = () => {
  const isMobile = useIsMobile();
  const { width: contentWidth, height: contentHeight } = useContentDimensions();
  const { navbarDimensions } = useLayoutDimensionsStore();
  const navbarHeight = navbarDimensions?.height ?? 0;

  useEffect(() => {
    document.documentElement.style.setProperty(TOP_NAV_HEIGHT_CSS_VAR, `${navbarHeight}px`);
    document.documentElement.style.setProperty(CONTENT_WIDTH_CSS_VAR, `${contentWidth}px`);
    document.documentElement.style.setProperty(CONTENT_HEIGHT_CSS_VAR, `${contentHeight}px`);
  }, [contentHeight, contentWidth, navbarHeight]);

  return <span data-mobile={isMobile} />;
};
